import { render, staticRenderFns } from "./TPayments.vue?vue&type=template&id=6b1d6779&"
import script from "./TPayments.vue?vue&type=script&lang=js&"
export * from "./TPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b1d6779')) {
      api.createRecord('6b1d6779', component.options)
    } else {
      api.reload('6b1d6779', component.options)
    }
    module.hot.accept("./TPayments.vue?vue&type=template&id=6b1d6779&", function () {
      api.rerender('6b1d6779', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/capsules/TPayments.vue"
export default component.exports